export var tooltipListWrap = {
  maxHeight: 300,
  overflowY: 'auto',
  width: 200
};
export var tooltipListItem = function tooltipListItem(theme) {
  return {
    padding: '1em',
    color: theme.gray700
  };
};
export var tableMoreLabel = function tableMoreLabel(theme) {
  return {
    color: theme.gray400,
    marginLeft: '0.5em',
    minWidth: 100,
    '& > i': {
      fontSize: 14
    },
    '&:hover > span': {
      textDecoration: 'underline'
    }
  };
};